import { TRANSACTION_SCORE_QUERY_KEYS } from 'app/modules/transactionScore/queries/keys';
import { get } from 'app/shared/utils/fetchr';
import { useQuery } from '@tanstack/react-query';
import { TransactionRiskScoreEvidenceResponse } from 'app/modules/transactionScore/responses';
import { TxnEventExternalId } from 'app/shared/types/eventExternalIds';

export const useGetTransactionRiskScoreEvidence = <
  TSelect = TransactionRiskScoreEvidenceResponse,
>(
  eventID: TxnEventExternalId,
  options?: {
    enabled?: boolean;
    select?: (data: TransactionRiskScoreEvidenceResponse) => TSelect;
  },
) => {
  return useQuery({
    queryFn: () =>
      get<TransactionRiskScoreEvidenceResponse>(
        `/v1/ml/txn-score/shap-values/${eventID}`,
      ),
    queryKey:
      TRANSACTION_SCORE_QUERY_KEYS.getTransactionRiskScoreEvidence(eventID),
    ...options,
  });
};
